import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';

import { Question } from 'src/app/models/survey/question';
import { QuestionType } from 'src/app/models/survey/questionType';
import { QuestionTypeService } from 'src/app/services/survey/question-type.service';
import { QuestionService } from '../../../../../../services/survey/question.service';

@Component({
  selector: 'app-svquestion-list',
  templateUrl: './svquestion-list.component.html',
  styleUrls: ['./svquestion-list.component.scss']
})
export class SvquestionListComponent implements OnInit {

  svquestion: Question[] = null;
  qtype: QuestionType[] = null;
  msg: Message = { status: null, message: null };
  hiddenMsg: boolean = true;
  idsectionSelected: string = null;

  constructor(
    private questionS: QuestionService,
    private activedRoute: ActivatedRoute,
    private qtypeS: QuestionTypeService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idsectionSelected = params['idsection'];
    this.getQuestionType();
    this.get4SectionAdm(params['idsection']);

  }

  get4SectionAdm(id: string) {
    this.questionS.get4SectionAdm(id).subscribe(
      res => {
        this.svquestion = res['data'];
        if (this.svquestion) {
          this.svquestion.forEach(q => {
            if (this.qtype) {
              this.qtype.forEach(qt => {
                if (q.idquestiontype == qt.id) {
                  q.questiontype = qt.label;
                }
              });
            }
          });
        }
      },
      err => { this.msg = err; }
    );
  }

  getQuestionType() {
    this.qtypeS.getAll().subscribe(
      res => { this.qtype = res['data']; },
      err => { this.msg = err; }
    );
  }

  remove(id: string) {
    this.questionS.delete(id).subscribe(
      res => {
        this.msg.message = res['message'];
        this.msg.status = res['status'];
        this.hiddenMsg = false;
        this.get4SectionAdm(this.idsectionSelected);
      },
      err => {
        this.msg.message = err["error"].message;
        this.msg.status = err["error"].status;
      }
    );
  }

}

